import axios from 'axios';

export default {
    state: {
        payments: [],
    },
    mutations: {
        SET_PAYMENTS(state, payments) {
            state.payments = payments;
        }
    },
    actions: {
        loadPayments({ commit }, params) {
            axios.get('api/payment/', {
                params
            }).then( response => {
                commit('SET_PAYMENTS', response.data);
            }, error => {
                console.log(error);
            })
        }
    }
}